import Roles from './roles';
import Permissions from './permissions';

const SecurityRoutes = [
  ...Roles,
  ...Permissions,
];

export default SecurityRoutes;
